import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import requestCheck from 'assets/images/Dashboard/chevron-right-request.svg';
import ArrowDetail from 'assets/images/Dashboard/arrow-left-request-detail.svg';
import MobileIcon from 'assets/images/Dashboard/call-request-detail.svg';
import MailIcon from 'assets/images/Dashboard/mail-request-detail.svg';
import ImageNull from 'assets/images/Dashboard/image-null.svg';
import Shimmer from 'components/commom/Shimmer';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import ArrowRightIcon from 'assets/images/Dashboard/ArrowRight-request.svg';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import Loader from 'components/commom/Loader';
import { scanResult } from 'routes/AppUrls';
import {
  basicDetailsValue,
  SCAN_RESULT,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';

const SkinAnalyserDetail = () => {
  const { locale } = useContext(LocaleContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const scanDetail = useSelector(
    (state) => state?.basicDetailsValueReducer?.scanDetails
  );

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, [scanDetail]);

  const handleDetail = (data) => {
    dispatch(basicDetailsValue(SCAN_RESULT, data));
    navigate(scanResult(locale));
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainerrequest lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainerrequest lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <div className="flex pb-16">
            <div className="fs-12 lh-24 family_outfit_regular_400">
              Skin Analyser
            </div>
            <div className="pl-04 flex items-center">
              <Image src={requestCheck} alt="icon" />
            </div>
            <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
              Skin Analyser Details
            </div>
          </div>
          <Row className="bg-light-100 m-0 p-24">
            <Col sm={12} className="p-0">
              <div className="flex">
                <div>
                  <Image
                    src={ArrowDetail}
                    alt="icon"
                    onClick={() => navigate(-1)}
                    className="cursor-pointer"
                  />
                </div>
                <div className="fs-20 lh-252 family_outfit_semiBold_600 fc-292D32 pl-12">
                  Patient Details
                </div>
              </div>
              <Row className="m-0 p-0">
                <Col md={4} className="p-0">
                  <div className="flex align-items-center pt-16">
                    <div className="uploadPhoto">
                      {loading ? (
                        <Shimmer
                          width="100px"
                          height="100px"
                          borderRadius="50%"
                        />
                      ) : (
                        <Image
                          src={
                            scanDetail?.patient_info?.profile_pic !== ''
                              ? scanDetail?.patient_info?.profile_pic
                                  ?.profile_image
                              : ImageNull
                          }
                          alt="Uploaded profile"
                          className={
                            scanDetail?.patient_info?.profile_pic
                              ? 'uploadPhoto'
                              : ''
                          }
                        />
                      )}
                    </div>
                    <div className="pl-12">
                      {loading ? (
                        <Shimmer width="250px" height="20px" />
                      ) : (
                        <p className="p-0 m-0 fs-20 family_outfit_medium_500 lh-252 fc-202224">
                          {scanDetail?.patient_info?.full_name}
                        </p>
                      )}
                      {loading ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'12px'}
                        />
                      ) : (
                        <p className="pt-12 m-0 fs-14 family_outfit_regular_400 lh-176 fc-A4AAB2">
                          ID:
                          <span className="fs-14 family_outfit_medium_500 lh-176 fc-202224">
                            {scanDetail?.patient_info?.patient_id}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                </Col>
                <Col md={8} className="p-0">
                  <Row className="p-0 m-0">
                    <Col md={8} className="p-0 m-0">
                      <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                        Contact Info
                      </div>
                      <Stack
                        direction="horizontal"
                        gap={5}
                        className="items-center p-0"
                      >
                        {loading ? (
                          <Shimmer
                            width="150px"
                            height="20px"
                            marginTop={'8px'}
                          />
                        ) : (
                          <div className="flex pt-8">
                            <div>
                              <Image src={MobileIcon} alt="icon" />
                            </div>
                            <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pl-12">
                              {scanDetail?.patient_info?.country_code}
                              {scanDetail?.patient_info?.contact_number}
                            </div>
                          </div>
                        )}
                        {loading ? (
                          <Shimmer
                            width="150px"
                            height="20px"
                            marginTop={'8px'}
                          />
                        ) : (
                          <div className="flex pt-8">
                            <div>
                              <Image src={MailIcon} alt="icon" />
                            </div>
                            <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pl-12 break-all ...">
                              {scanDetail?.patient_info?.email}
                            </div>
                          </div>
                        )}
                      </Stack>
                    </Col>
                    <Col md={4} className="p-0 m-0">
                      <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                        Total Used Scan
                      </div>
                      {loading ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'8px'}
                        />
                      ) : (
                        <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                          {scanDetail?.total_scans}
                        </div>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          {loading ? (
            <Loader marginTop={'20vh'} />
          ) : (
            <div className="pt-20 mb-[50px]">
              <Row className="listCustomHeader m-0 p-0 flex items-center">
                <Col lg={3} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Image" />
                  </p>
                </Col>
                <Col lg={3} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Scanning Date" />
                  </p>
                </Col>
                <Col lg={4} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Status" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Actions" />
                  </p>
                </Col>
              </Row>
              {scanDetail && scanDetail?.scan_details?.length > 0 ? (
                <Row className="bc-FFFFFF m-0 p-0">
                  {scanDetail?.scan_details?.map((item, index) => {
                    return (
                      <Row
                        className="m-0 p-0 flex items-center listAppointment"
                        key={index}
                      >
                        <Col lg={3} md={6} sm={12}>
                          <Zoom>
                            <Image
                              src={item?.original_image}
                              alt={'icon'}
                              style={{
                                height: '60px',
                                width: '50px',
                              }}
                            />
                          </Zoom>
                        </Col>
                        <Col lg={3} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                            {moment(item?.scanning_date).format('DD MMM YYYY')}
                          </div>
                        </Col>
                        <Col lg={4} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                            {item?.status}
                          </div>
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <Stack
                            direction="horizontal"
                            gap={1}
                            className="items-center cursor-pointer"
                          >
                            <div
                              className="fs-14 fc-202224 lh-176 family_outfit_medium_500 underline underline-offset-4"
                              onClick={() => {
                                handleDetail(item);
                              }}
                            >
                              <FormattedMessage id="View Details" />
                            </div>
                            <Image
                              src={ArrowRightIcon}
                              alt="icon"
                              onClick={() => {
                                handleDetail(item);
                              }}
                            />
                          </Stack>
                        </Col>
                      </Row>
                    );
                  })}
                </Row>
              ) : (
                <div className="flex justify-center pt-120">
                  <div>
                    <Image src={EmptyScreen} alt="icon" />
                    <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                      Nothing here yet
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SkinAnalyserDetail;
